var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99359 7.83325H42.0061C42.2917 7.83325 42.5657 7.96091 42.7677 8.18816C42.9697 8.4154 43.0832 8.7236 43.0832 9.04497V18.1439C43.0832 19.1044 42.915 20.0555 42.5883 20.943C42.2615 21.8304 41.7826 22.6367 41.1789 23.3159C40.5751 23.9951 39.8584 24.5339 39.0696 24.9015C38.2808 25.2691 37.4353 25.4583 36.5815 25.4583H10.4182C9.56436 25.4583 8.71891 25.2691 7.93009 24.9015C7.14127 24.5339 6.42453 23.9951 5.8208 23.3159C4.6015 21.9442 3.9165 20.0838 3.9165 18.1439V9.04497C3.9165 8.7236 4.02998 8.4154 4.23197 8.18816C4.43397 7.96091 4.70793 7.83325 4.99359 7.83325V7.83325Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0873 29.375C33.4626 30.2261 33.1891 31.2849 33.3236 32.3321C33.6565 33.8792 35.1056 34.2904 35.2819 35.7788C35.3233 36.3361 35.2372 36.8955 35.0302 37.4147C34.8232 37.9338 34.5008 38.399 34.0873 38.775",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.542 29.6104C22.9242 30.4643 22.6578 31.5228 22.7979 32.5674C23.1112 34.1145 24.58 34.5258 24.7562 35.9945C24.7866 36.5456 24.6913 37.0964 24.4775 37.6053C24.2638 38.1142 23.9372 38.5679 23.5225 38.932",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5505 29.375C11.9182 30.2225 11.644 31.2844 11.7868 32.3321C12.1001 33.8792 13.5688 34.2904 13.7451 35.7788C13.7749 36.3251 13.6812 36.8711 13.471 37.3763C13.2608 37.8814 12.9395 38.3327 12.5309 38.6967",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83301 19.5833H37.678",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83301 15.6665H15.6663",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/AC.2198d256b2cb75fbd50c7e641e20a1f9.svg";
export { ForwardRef as ReactComponent };